import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { issuesAPI } from '../../services/api';
import { LoadingPage } from '../../components/Loading';
import { useToast } from '../../context/ToastContext';
import './Admin.css';

const emptyForm = {
  title: '',
  slug: '',
  description: '',
  current_status: '',
  progress: '',
  future_plans: '',
  display_order: 0,
  is_active: true,
  is_featured: false,
};

const IssueForm = () => {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();
  const { success, error } = useToast();
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(isEdit);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isEdit) {
      fetchIssue();
    }
  }, [id]);

  const fetchIssue = async () => {
    try {
      setLoading(true);
      const response = await issuesAPI.getById(id);
      setForm({ ...emptyForm, ...response.data });
    } catch (err) {
      error('無法載入議題資料');
      navigate('/admin/issues');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        ...form,
        display_order: Number(form.display_order) || 0,
      };
      if (isEdit) {
        await issuesAPI.update(id, payload);
        success('議題已更新');
      } else {
        await issuesAPI.create(payload);
        success('議題已建立');
      }
      navigate('/admin/issues');
    } catch (err) {
      error(isEdit ? '更新失敗' : '建立失敗');
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <LoadingPage message="載入議題資料中..." />;

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>{isEdit ? '編輯核心服務' : '新增核心服務'}</h1>
      </div>

      <form className="admin-form card" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>標題 *</label>
            <input name="title" value={form.title} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>網址名稱 (留空自動產生)</label>
            <input name="slug" value={form.slug || ''} onChange={handleChange} />
          </div>
        </div>

        <div className="form-group">
          <label>描述 *</label>
          <textarea name="description" value={form.description} onChange={handleChange} rows={4} required />
        </div>

        <div className="form-group">
          <label>現狀說明</label>
          <textarea name="current_status" value={form.current_status || ''} onChange={handleChange} rows={3} />
        </div>

        <div className="form-group">
          <label>進展情況</label>
          <textarea name="progress" value={form.progress || ''} onChange={handleChange} rows={3} />
        </div>

        <div className="form-group">
          <label>未來計劃</label>
          <textarea name="future_plans" value={form.future_plans || ''} onChange={handleChange} rows={3} />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>顯示順序</label>
            <input name="display_order" type="number" value={form.display_order} onChange={handleChange} />
          </div>
          <div className="form-group checkbox-group">
            <label>
              <input name="is_active" type="checkbox" checked={form.is_active} onChange={handleChange} />
              啟用
            </label>
            <label>
              <input name="is_featured" type="checkbox" checked={form.is_featured} onChange={handleChange} />
              精選
            </label>
          </div>
        </div>

        <div className="form-actions">
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/admin/issues')}>
            取消
          </button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? '儲存中...' : '儲存'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default IssueForm;
